"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useActiveUser = exports.effectiveScopes = exports.PERMISSIONS_SCOPES = exports.EMPTY_USER = void 0;
var client_1 = require("@apollo/client");
var auth0_react_1 = require("@auth0/auth0-react");
var lodash_1 = require("lodash");
var react_1 = require("react");
var application_context_1 = require("../components/context/application-context");
exports.EMPTY_USER = {
  name: '',
  nickname: '',
  picture: '',
  user_id: '',
  clientID: '',
  identities: [],
  /* @ts-ignore */
  created_at: '',
  updated_at: '',
  sub: ''
};
exports.PERMISSIONS_SCOPES = ['openid', 'profile', 'email', 'user_metadata', 'app_metadata'];
var effectiveScopes = function (scope) {
  return __spreadArray(__spreadArray([], __read(exports.PERMISSIONS_SCOPES), false), __read(scope), false);
};
exports.effectiveScopes = effectiveScopes;
var useActiveUser = function () {
  var activeUserQuery = (0, react_1.useContext)(application_context_1.ApplicationContext).activeUserQuery;
  var _a = (0, auth0_react_1.useAuth0)(),
    _b = _a.user,
    user = _b === void 0 ? exports.EMPTY_USER : _b,
    error = _a.error,
    isAuthenticated = _a.isAuthenticated;
  // We need to query our own GraphQL server to retrieve metadata
  // which contains agreesToTerms, mustChangePassword etc.
  // This is because Auth0 does not support passing through metadata
  // to the objects their hook returns, without using Auth0 "hooks"
  // in each tenant, which is something we'd prefer not to do as it adds more
  // dependence on their stack.
  // note, this may query with an empty user id, but that's okay
  var _c = (0, client_1.useQuery)(activeUserQuery, {
      variables: {
        id: (0, lodash_1.get)(user, 'sub', '')
      }
    }),
    loading = _c.loading,
    data = _c.data;
  return (0, react_1.useMemo)(function () {
    // console.log(data);
    var userRecord = (0, lodash_1.get)(data, 'user') || {};
    var nameParts = user.name && user.name.split && user.name.split(' ');
    var givenName = nameParts.length !== 0 && nameParts[0];
    var familyName = nameParts.length > 1 && nameParts[nameParts.length - 1];
    var activeUser = {
      loading: loading,
      id: user.sub,
      name: user.name,
      slug: (0, lodash_1.kebabCase)(user.name),
      updateDate: user.updated_at,
      email: user.email,
      picture: user.picture,
      agreesToTerms: !!userRecord.agreesToTerms,
      mustChangePassword: !!userRecord.mustChangePassword,
      givenName: givenName,
      familyName: familyName,
      personId: userRecord.person && userRecord.person.id,
      permissions: userRecord.permissions || []
    };
    // console.log(activeUser);
    return activeUser;
  }, [user, loading, data, isAuthenticated]);
};
exports.useActiveUser = useActiveUser;